const fontFiles = {
  watch: [
    "/fonts/merriweather-078faa192aeb0a99.woff2",
    "/fonts/merriweather-a3289cbf5bb77bb5.woff2",
    "/fonts/merriweather-sans-69a9465bc51cf625.woff2",
    "/fonts/merriweather-sans-7f7b0fb7bb5927f0.woff2",
  ],
  sugarscape: [
    "/fonts/fraunces-109c501a32c8040e.woff2",
    "/fonts/fraunces-ae1d21f0a3120a56.woff2",
    "/fonts/space-grotesk-a0d054c4af557de2.woff2",
  ],
} as const;

export function FontPreloads({ group }: { group: keyof typeof fontFiles }) {
  return fontFiles[group].map((href) => (
    <link
      key={href}
      rel="preload"
      as="font"
      type="font/woff2"
      href={href}
      crossOrigin="anonymous"
    />
  ));
}
